module.exports = __webpack_public_path__ + "static/media/digital-marketing-circle.f02ff477.svg";